export const emptyUser = {
  gender: '',
  name: {
    title: '',
    first: '',
    last: '',
  },
  location: {
    street: {
      number: '',
      name: '',
    },
    city: '',
    state: '',
    country: '',
    postcode: '',
    coordinates: {
      latitude: '',
      longitude: '',
    },
    timezone: {
      offset: '-',
      description: '',
    },
  },
  email: '',
  login: {
    uuid: '',
    username: '',
    password: '',
    salt: '',
    md5: '',
    sha1: '',
    sha256: '',
  },
  dob: {
    date: '',
    age: 0,
  },
  picture: {
    large: 'https://randomuser.me/api/portraits/men/0.jpg',
    medium: 'https://randomuser.me/api/portraits/med/men/0.jpg',
    thumbnail: 'https://randomuser.me/api/portraits/thumb/men/0.jpg',
  },
  realLocation: {
    country: '',
    coords: [],
  },
};
